import { VALTYPES } from '../../../../data/interfaces';
import { categoricalOrderOptions } from '../../helpers/categoricalSorters';
import {
  createConfigParamBoolean,
  createConfigParamLabelSpace,
  createConfigParamMultipleChoice,
  createConfigParamTypeDiscreteColorScheme,
} from '../../helpers/configParams';
import { CONFIGPARAM_VISIBILITYCONDITION_TYPES, TpChartManifest } from '../interfaces';
import { Bargraph } from './Bargraph';

export const manifestBargraph: TpChartManifest = {
  id: 'BarGraph',
  name: 'Bar graph',
  description:
    'Displays the distribution of a categorical property by showing the number of occurrences of each different state.',
  component: Bargraph,
  canvasBased: true,
  groups: [
    { groupId: 'bars', groupName: 'Categories' },
    { groupId: 'colors', groupName: 'Colors' },
  ],
  aspects: [
    {
      id: 'value',
      name: 'Categories data',
      groupId: 'bars',
      description: 'Property to show the states and occurrences for.',
      required: true,
      quality: 1,
      dataType: [VALTYPES.CATEGORICAL, VALTYPES.MULTICAT],
    },
    {
      id: 'color',
      name: 'Color data',
      groupId: 'colors',
      description:
        'An optional second categorical property that is used to divide and color code each state of the `value` property.',
      required: false,
      quality: 0.25,
      dataType: VALTYPES.CATEGORICAL,
    },
  ],
  configParams: [
    {
      id: 'sortBy',
      name: 'Sort by',
      groupId: 'bars',
      description: 'How to sort the bars (states of the `value` property).',
      paramType: createConfigParamMultipleChoice(categoricalOrderOptions),
    },
    {
      id: 'labelSpace',
      name: 'Label space',
      groupId: 'bars',
      description:
        'Scaling factor that determines how much space in the chart is used by the names of the different states.',
      paramType: createConfigParamLabelSpace(),
    },
    {
      id: 'yAxisType',
      name: 'Y Axis',
      groupId: 'colors',
      description:
        'Defines the type of vertical axis. If the `color` aspect is defined, this can be used to visualize the relative proportion of each state.',
      paramType: createConfigParamMultipleChoice([
        { id: 'count', name: 'Count' },
        { id: 'percentage', name: 'Percentage' },
      ]),
      visibilityConditions: [
        {
          conditionType: CONFIGPARAM_VISIBILITYCONDITION_TYPES.FACET_BOUND,
          conditionInfo: {
            facet: 'color',
          },
        },
      ],
    },
    {
      id: 'showTotalCount',
      name: 'Scale Y axis to row count',
      groupId: 'bars',
      description:
        'If enabled, the vertical axis will be scaled to the total number of rows in the dataset, rather than the maximum count of occurrences.',
      paramType: createConfigParamBoolean(false),
      visibilityConditions: [
        {
          conditionType: CONFIGPARAM_VISIBILITYCONDITION_TYPES.CONFIG_VALUE,
          conditionInfo: {
            configParam: 'yAxisType',
            configValue: 'count',
          },
        },
      ],
    },
    {
      id: 'colorSchemeCategorical',
      name: 'Color scheme',
      groupId: 'colors',
      paramType: createConfigParamTypeDiscreteColorScheme(),
      visibilityConditions: [
        {
          conditionType: CONFIGPARAM_VISIBILITYCONDITION_TYPES.FACET_BOUND,
          conditionInfo: {
            facet: 'color',
          },
        },
      ],
    },
  ],

  examples: [
    {
      id: 'barchart_1',
    },
    {
      id: 'barchart_2',
    },
  ],
};
